// extracted by mini-css-extract-plugin
export default {"ToggleButtonContainer":"ToggleButtonContainer_fYZXo","sizeMedium":"sizeMedium_ZabMg","sizeLarge":"sizeLarge_RZph0","ToggleOn":"ToggleOn_gkGHd"};